export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const ID = 'ID';
export const NAME = 'NAME';
export const USERNAME = 'USERNAME';
export const EMAIL = 'EMAIL';
export const ROLE_ID = 'ROLE_ID';
export const IMAGE = 'IMAGE';
export const PASSWORD = 'PASSWORD';
export const PASSWORD_CONFIRMATION = 'PASSWORD_CONFIRMATION';
export const CURRENT_LANG = 'CURRENT_LANG';
export const CURRENT_DIRECTION = 'CURRENT_DIRECTION';
export const DEFAULT_LANGUAGE = 'DEFAULT_LANGUAGE';
export const DEFAULT_DIRECTION = 'DEFAULT_DIRECTION';
export const CREATED_AT = 'CREATED_AT';
export const UPDATED_AT = 'UPDATED_AT';
export const BADGES = 'BADGES';
export const CERTIFICATES = 'CERTIFICATES';
export const WORKSPACE_LANGUAGE_LOADED = 'WORKSPACE_LANGUAGE_LOADED';
export const LESSON_DASHBOARD = 'LESSON_DASHBOARD';



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutation-types.js